'use client'

import { cn } from '@/components/ui/utils'
import { CurrencyCode, useLanguage } from '@/components/i18n/LanguageProvider'

type Props = { className?: string }

const options = ['TND', 'EUR', 'USD'] as const

export function CurrencyToggle({ className }: Props) {
  const { currencyCode, setCurrency } = useLanguage()

  return (
    <select
      value={currencyCode}
      onChange={(e) => setCurrency(e.target.value as CurrencyCode)}
      className={cn(
        'h-9 rounded-full border border-border bg-background px-3 text-xs font-semibold text-muted-foreground shadow-sm transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30',
        className
      )}
      aria-label="Currency"
    >
      {options.map((code) => (
        <option key={code} value={code}>
          {code}
        </option>
      ))}
    </select>
  )
}
